import React, { Component } from 'react'

class Page404 extends Component {
  render () {
    return (
      <div>
        <section>
          <h1>404</h1>
          <p>OH NO!</p>
          <p>NOTHING DWELLS HERE.</p>
        </section>
      </div>
    )
  }
}

export default Page404



// WEBPACK FOOTER //
// ./404.js